<template>
  <b-carousel
    v-model="slide"
    :interval="0"
  >
    <b-carousel-slide
      v-for="(children, index) in flatTree"
      :key="index"
    >
      <b-card
        slot="img"
        no-body
      >
        <b-list-group flush>
          <b-list-group-item
            v-if="index > 0"
            button
            @click="back"
          >
            <strong>Back</strong>
          </b-list-group-item>
          <b-list-group-item
            v-for="tab in tabs"
            v-show="index === 0"
            :key="tab.path"
            :active="storyPath.toString() === tab.path"
            button
            @click="selectActiveNode(tab)"
          >
            {{ title(tab.path) }}
          </b-list-group-item>
          <b-list-group-item
            v-for="sibling in children"
            :key="sibling.path"
            :active="storyPath.equals(sibling.path)"
            button
            @click="selectActiveNode(sibling)"
          >
            {{ title(sibling.path) ? title(sibling.path) : sibling.data ? sibling.data[projectLabelField] : '' }}
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-carousel-slide>
  </b-carousel>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { PathItem } from '@/store/primary/entities/tabs'
import { Path, TreeNode } from '@/types'

@Component
export default class MobileNavigation extends Vue {
  slide = 0

  mounted () {
    this.focusOnCurrentNode()
  }

  get tabs () {
    return this.$typedStore.primary.entities.tabs.primaryRootTabPaths
  }

  get flatTree () {
    if (this.storyPath.isRootOrSubroot) return [this.sortedRootChildren]
    else {
      const pathItems = this.storyPath.partPaths
      return pathItems.reduce((accumulator, currentValue, currentIndex) => {
        const drillDownPath = this.storyPath.ancestorPath(currentIndex + 1)
        const children = this.$typedStore.visualisationData.childrenByPath(drillDownPath)
        if (children) accumulator.push(children)
        return accumulator
      }, [this.sortedRootChildren])
    }
  }

  get sortedRootChildren () {
    return this.$typedStore.visualisationData.sortedRootChildren
  }

  get storyPath () {
    return this.$typedStore.public.display.storyPath
  }

  get currentNode () {
    return this.$typedStore.visualisationData.treeRoot.search(this.storyPath)
  }

  get projectLabelField () {
    return this.$typedStore.primary.app.config.appConfig.projectLabelField
  }

  focusOnCurrentNode () {
    if (this.currentNode !== false) this.slide = this.storyPath.level
  }

  title (path: string|Path) {
    const name = this.$typedStore.primary.entities.nodes.name(path)
    const label = this.$typedStore.primary.entities.nodes.label(path)
    return label || name
  }

  back () {
    if (this.slide > 0) this.slide--
  }

  async selectActiveNode (node: PathItem | TreeNode) {
    await this.updateActiveNode(node.path.toString())
    this.slide = this.flatTree.length - 1
    if ('children' in node && node.children === null) this.$bvModal.hide('modal-nav')
  }

  async updateActiveNode (path: string) {
    await this.$typedStore.public.display.updatePrimaryStoryPath(path)
    this.$analytics.event('click', {
      event_category: 'side-tab',
      event_label: path,
    })
  }
}

</script>
